import { render, staticRenderFns } from "./ClientsListFilters.vue?vue&type=template&id=ae06d7f4&"
import script from "./ClientsListFilters.vue?vue&type=script&lang=js&"
export * from "./ClientsListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports